var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 142.106,
    height: 93,
    viewBox: "0 0 142.106 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M83.533-144.826c13.246,4.286,24.525,14.716,30.217,30.582h26.824a1.533,1.533,0,0,1,1.533,1.538,1.523,1.523,0,0,1-1.533,1.483H112.765a1.482,1.482,0,0,1-1.424-1.041c-5.311-15.649-16.149-25.534-28.792-29.6s-27.26-2.252-40.016,5.926a1.62,1.62,0,0,1-2.354-.327,1.627,1.627,0,0,1,.712-2.252,50.654,50.654,0,0,1,42.642-6.314ZM71.248-120.173a19.971,19.971,0,0,1,20.09,19.879A20.021,20.021,0,0,1,71.248-80.36a20.056,20.056,0,0,1-20.09-19.934A20.01,20.01,0,0,1,71.248-120.173ZM29.666-89.805a1.677,1.677,0,0,1,1.147,1.041c5.256,15.649,16.095,25.588,28.738,29.6,12.7,4.062,27.26,2.252,40.016-5.878a1.571,1.571,0,0,1,2.354.272,1.615,1.615,0,0,1-.712,2.252C87.745-53.9,72.194-51.868,58.622-56.208,45.321-60.494,34.1-70.924,28.405-86.736H1.581A1.607,1.607,0,0,1,0-88.267,1.66,1.66,0,0,1,1.587-89.8Z",
    transform: "translate(0 147)",
    fill: "#00baef"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M-209,432.879H541.95V-456H-209Z",
    transform: "translate(209 456)",
    fill: "#00baef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    "data-name": "Group 832",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831",
    transform: "translate(-129.924 -195.49)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M-5-152H143.323v99.327H-5Z",
    transform: "translate(131.816 344.327)",
    fill: "#00baef"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.4daea077e8303cb90ab8362df5a7da9c.svg";
export { ForwardRef as ReactComponent };